import React from "react";
import SimpleLookupPage from "./SimpleLookupPage";
import useDeliveryServices from "../../hooks/useDeliveryServices";

export default function DeliveryServicesPage() {
    const {
        deliveryServices,
        loading,
        error,
        fetchDeliveryServices,
        createDeliveryService,
        updateDeliveryService,
        deleteDeliveryService,
    } = useDeliveryServices();

    return (
        <SimpleLookupPage
            title="Lieferservice"
            itemLabel="Lieferservice"
            searchLabel="Lieferservice suchen"
            items={deliveryServices}
            loading={loading}
            error={error}
            fetchItems={fetchDeliveryServices}
            createItem={createDeliveryService}
            updateItem={updateDeliveryService}
            deleteItem={deleteDeliveryService}
        />
    );
}
